import { JtechAxios } from 'src/plugins/axios'

export const LayoutRepository = {
  findModules: async function () {
    try {
      const dataResponse = await JtechAxios.request().get('fw-data/componenteMenuAcessoFW?method=getDadosMenuPadrao')
      return Array.from(dataResponse.data.modulos)
    } catch (ex) {
    }
  },

  reloadConfigurations: async function () {
    try {
      await JtechAxios.request().post('fw-data/atualizarConfiguracaoFW.ajax?method=atualizarCfg')
    } catch (ex) {
    }
  }
}
